import { ColumnDef } from '@tanstack/react-table';
import IndeterminateCheckbox from '../IndeterminateCheckbox/IndeterminateCheckbox';
import cn from 'classnames';

import styles from './SelectionColumn.module.css';

/**
 * Creates a selection column definition for row selection functionality
 */
export function createSelectionColumn<T>(): ColumnDef<T> {
  return {
    id: 'select',
    enableResizing: false,
    maxSize: 40,
    header: ({ table }) => (
      <label
        className={cn(styles.label, styles.headerLabel)}
        data-selection-column='true'
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <div className={styles.container}>
          <IndeterminateCheckbox
            checked={table.getIsAllRowsSelected()}
            indeterminate={table.getIsSomeRowsSelected()}
            onChange={table.getToggleAllRowsSelectedHandler()}
          />
        </div>
      </label>
    ),
    cell: ({ row }) => (
      <label
        className={styles.label}
        data-selection-column='true'
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <div className={styles.container}>
          <IndeterminateCheckbox
            checked={row.getIsSelected()}
            disabled={!row.getCanSelect()}
            indeterminate={row.getIsSomeSelected()}
            onChange={row.getToggleSelectedHandler()}
          />
        </div>
      </label>
    ),
  };
}
